module.exports = __webpack_public_path__ + "img/jpm.3b40eeff.svg";